import { resultSchema } from "../schema/result.schema";

export const USERMUTATION = `mutation ($user: UserIn!) {
    user(user: $user) {
    ${resultSchema}
    }
}`;
